import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import { getPriceCountries } from "../../store/middleware";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import Engrenagem from "../../assets/images/icons/icon_settings_header.svg";

import { Table } from "./styles";

function Countries() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [paymentMethodId, setPaymentMethodId] = useState([]);

  useEffect(() => {
    dispatch(getPriceCountries()).then((res) => setPaymentMethodId(res));
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header
          title="Countries"
          icon={<img src={Engrenagem} alt="Engrenagem" />}
          typeIcon="custom"
          rightButton={
            <button className="buttonRight" onClick={() => navigate("/countries/new")}>
              <i className="fa fa-plus" aria-hidden="true" />
              Add New Country
            </button>
          }
          t={t}
        />

        <div className="content">
          <Table>
            <div className="bigBoxTableCountries">
              <table>
                <tbody>
                  <tr>
                    <th>Country</th>
                    <th>Language</th>
                    <th>Standard payment</th>
                    <th>Standard currency</th>
                    <th>Standard country</th>
                    <th>{t("EXTRA_CLASS")} %</th>
                    <th>Status</th>
                  </tr>

                  {paymentMethodId?.map((country) => (
                    <tr key={country.id}>
                      <td>{decryptIfEncrypted(country.country.name)}</td>
                      <td>{decryptIfEncrypted(country.lingoLanguage.language.name)}</td>
                      <td>{country.paymentMethod}</td>
                      <td>{country.standardCurrency}</td>
                      <td>{country.defaultCountry ? "Sim" : "Não"}</td>
                      <td>{country.extraClassPercentage && country.extraClassPercentage}</td>
                      <td>
                        <span style={{ color: country.active ? "#0ED572" : "#FF5666" }}>
                          {country.active ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <Link to={`/countries/${country.id}`} state={{ data: country }}>
                          <button>
                            View <i className="fa fa-angle-right" aria-hidden="true"></i>
                          </button>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Table>
        </div>
      </section>
    </div>
  );
}

export default Countries;
